import React from "react"
import { Control, Controller } from "react-hook-form"
import Input from "../../Ui/Form/Input"
import { SidebarDivider } from "../../DashboardSales/Shared.styled"
import { FieldErrors } from "react-hook-form/dist/types/errors"
import { ExternalPriceConfig, InputExternalPriceConfig } from "lib/types/generated/graphql-types"
import { WithAuth } from "../../Auth"
import { PermissionGroups } from "../../../routes/constants"
import FallbackInput from "../../Ui/Form/FallbackInput"

interface ExtendedInputExternalPriceConfig extends InputExternalPriceConfig {
  id: string
}

type Props = {
  control: Control<ExtendedInputExternalPriceConfig>
  errors: FieldErrors
  showId?: boolean
  defaultValues?: ExternalPriceConfig
}

const ExternalPriceConfigInput = ({ control, errors, showId, defaultValues }: Props) => {
  const isValidHttpUrl = (string: string) => {
    try {
      const newUrl = new URL(string)
      return newUrl.protocol === "https:"
    } catch (err) {
      console.error(err)
      return false
    }
  }

  return (
    <>
      {showId && (
        <Controller
          name="id"
          render={({ field }) => (
            <Input
              {...field}
              type="text"
              label="Identifier *"
              description="For internal use in Brink"
              placeholder="Aa - Zz, 0 - 9, -_."
              errors={errors}
            />
          )}
          control={control}
          rules={{
            required: "This is a required field",
            pattern: {
              value: /^[A-Za-z0-9_.-]+$/,
              message: "Only characters Aa-Zz and 0-9 are allowed. No spaces"
            }
          }}
          defaultValue=""
        />
      )}
      <SidebarDivider />
      <WithAuth
        requiredGroups={PermissionGroups.providers.write}
        fallback={<FallbackInput label={"Base URL"} value={defaultValues?.baseUrl} />}
      >
        <Controller
          name="baseUrl"
          render={({ field }) => (
            <Input {...field} type="text" label="Base URL *" errors={errors} />
          )}
          control={control}
          rules={{
            validate: {
              url: (value) => {
                if (!isValidHttpUrl(value)) return "Must be https format"
              }
            },
            required: "This is a required field"
          }}
          defaultValue={defaultValues?.baseUrl ?? ""}
        />
      </WithAuth>
      <WithAuth requiredGroups={PermissionGroups.providers.write} fallback={<FallbackInput label={"Auth URL"} value={defaultValues?.authUrl} />}>
        <Controller
          name="authUrl"
          render={({ field }) => <Input {...field} type="text" errors={errors} label="Auth URL *" />}
          control={control}
          rules={{
            validate: {
              url: (value) => {
                if (!isValidHttpUrl(value)) return "Must be https format"
              }
            },
            required: "This is a required field"
          }}
          defaultValue={defaultValues?.authUrl ?? ""}
        />
      </WithAuth>
      <WithAuth requiredGroups={PermissionGroups.providers.write}>
        <Controller
          name="clientId"
          render={({ field }) => <Input {...field} type="text" errors={errors} label="Client ID *" />}
          control={control}
          rules={{
            required: "This is a required field"
          }}
          defaultValue=""
        />
        <Controller
          name="clientSecret"
          render={({ field }) => (
            <Input {...field} type="text" errors={errors} label="Client secret *" />
          )}
          control={control}
          rules={{
            required: "This is a required field"
          }}
          defaultValue=""
        />
      </WithAuth>
    </>
  )
}

export default ExternalPriceConfigInput
